module.exports = __webpack_public_path__ + "static/media/asugrid.9978a325.png";